// @ts-nocheck
/**
 * Auth-related API wrappers (separate from sessionsApi which is mapping-session CRUD).
 */

const BASE = import.meta.env.VITE_BACKEND_BASE_URL;
const API_KEY = import.meta.env.VITE_API_KEY;

/**
 * Ask the backend whether the HttpOnly session_token cookie is still valid.
 * Used on app mount to decide whether the user is authenticated independently
 * of the Supabase client's localStorage state.
 *
 * Returns the session status object on 200, or null on 401/network error
 * (caller treats null as "not authenticated via cookie").
 */
export async function getSessionStatus() {
  try {
    const res = await fetch(`${BASE}/auth/session-status`, {
      credentials: 'include',
      headers: { 'x-api-key': API_KEY },
    });
    if (!res.ok) return null;
    return res.json();
  } catch (_err) {
    return null;
  }
}
